import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import {
	Alert,
	Box,
	Grow,
	Link,
	Paper,
	TextField,
	Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import AuthContext from '../Context/Auth/AuthContext';
import logoNoBg from '../Assets/img/logoNoBg.png';

export default function Login() {
	const { isAuth, handleLogin } = useContext(AuthContext);

	const RegisterSchema = Yup.object().shape({
		email: Yup.string().email().required('Es un campo requerido.'),
		pwd: Yup.string()
			.min(6, 'Debe cotener mínimo 6 caracteres')
			.required('Es un campo requerido.'),
	});

	const navigate = useNavigate();
	useEffect(() => {
		if (isAuth) {
			navigate('/');
		}
	}, [isAuth]);

	return (
		<Paper
			elevation={3}
			sx={{
				backgroundColor: '#F2A413',
				height: '100vh',
				width: '100%',
				position: 'fixed',
				left: 0,
				right: 0,
			}}
		>
			<Box
				sx={{
					width: '100%',
					height: { xsm: '40vh' },
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<img
					src={logoNoBg}
					alt={logoNoBg}
					style={{
						display: 'block',
						margin: '0 auto',
						width: '50%',
						height: 'auto',
						maxWidth: 240,
					}}
				/>
			</Box>
			<Box
				sx={{
					backgroundColor: '#FFFFFF',
					height: { xsm: '60vh' },
					borderRadius: '40px 40px 0px 0px',
					position: 'fixed',
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 0,
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				<Box
					sx={{
						width: '90%',
						display: 'flex',
						textAlign: 'center',
						margin: '0 auto',
						flexDirection: 'column',
						marginTop: '20px',
						maxWidth: { sm: '500px' },
					}}
				>
					<Typography
						variant='h5'
						color='primary'
						fontWeight='bold'
						marginY={2}
					>
						Iniciar sesión
					</Typography>
					<Formik
						initialValues={{ email: '', pwd: '' }}
						validationSchema={RegisterSchema}
						onSubmit={handleLogin}
					>
						{({
							isSubmitting,
							status,
							values,
							errors,
							touched,
							dirty,
							isValid,
						}) => (
							<Form>
								<Field
									type='email'
									required
									margin='dense'
									id='email'
									name='email'
									value={values.email}
									as={TextField}
									label='Correo electrónico'
									fullWidth
									variant='outlined'
									error={errors.email && touched.email}
									helperText={touched.email && errors.email}
									sx={{ marginY: 1 }}
								/>
								<Field
									type='password'
									required
									margin='dense'
									id='pwd'
									name='pwd'
									value={values.pwd}
									as={TextField}
									label='Password'
									fullWidth
									variant='outlined'
									error={errors.pwd && touched.pwd}
									helperText={touched.pwd && errors.pwd}
									sx={{ marginY: 1 }}
								/>
								<LoadingButton
									disabled={!(isValid && dirty)}
									type='submit'
									sx={{ marginY: 2 }}
									loading={isSubmitting}
									variant='contained'
								>
									Entrar
								</LoadingButton>
								{status && (
									<Grow in={Boolean(status)}>
										<Alert severity='error'>{status?.error}</Alert>
									</Grow>
								)}
							</Form>
						)}
					</Formik>
					<Link href='/restore-password'>¿Olvidaste tu contraseña?</Link>
				</Box>
			</Box>
		</Paper>
	);
}
